import { render, staticRenderFns } from "./RemittancesDrawMoney.vue?vue&type=template&id=92e5879c&scoped=true&"
import script from "./RemittancesDrawMoney.vue?vue&type=script&lang=js&"
export * from "./RemittancesDrawMoney.vue?vue&type=script&lang=js&"
import style0 from "./RemittancesDrawMoney.vue?vue&type=style&index=0&id=92e5879c&lang=less&scoped=true&"
import style1 from "./RemittancesDrawMoney.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e5879c",
  null
  
)

export default component.exports